import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheapestLoan = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M46.3469 43.5566L53.8911 51.1008",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.7998 40.884C44.7998 43.8195 42.4201 46.1992 39.4846 46.1992L16.5151 46.1992C13.5795 46.1992 11.1998 43.8195 11.1998 40.884L11.1998 5.31448C11.1998 2.37895 13.5795 -0.000777335 16.5151 -0.000777079L39.4846 -0.000775071C42.4201 -0.000774814 44.7998 2.37894 44.7998 5.31448L44.7998 40.884Z",
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.2851 54.2586L7.63073 54.2586C5.15602 54.2586 3.14987 52.2524 3.14987 49.7777L3.14988 12.4444C3.14988 9.9697 5.15603 7.96354 7.63074 7.96354L35.2851 7.96355C37.7598 7.96355 39.7659 9.9697 39.7659 12.4444L39.7659 49.7777C39.7659 52.2524 37.7598 54.2586 35.2851 54.2586Z",
			stroke: "#031839",
			strokeWidth: 2.1
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 38.0504,
			cy: 35.9523,
			r: 11.3944,
			fill: "white",
			stroke: "#031839",
			strokeWidth: 2.1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1619 19.3574L29.7545 19.3574",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1619 23.5078L29.7545 23.5078",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3105 15.209L21.4587 15.209L25.6068 15.209",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41 31L35 41",
			stroke: "#031839",
			strokeWidth: 1.9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 35,
			cy: 33,
			r: 1.25,
			stroke: "#031839",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 41,
			cy: 39,
			r: 1.25,
			stroke: "#031839",
			strokeWidth: 1.5
		})
	]
});
export default SvgCheapestLoan;
